import { FormEvent } from 'react';
import { useFormContext } from 'react-hook-form';
import { When } from 'react-if';
import { useTranslation } from 'next-i18next';
import { Input, Spacing, Stack, TextField } from '@zep/ui';
import { PlanCheckoutFormSchemaType } from '../hooks/usePlanCheckoutForm';
import { PaymentInformationProps, ReusablePaymentInformation } from './ReusablePaymentInformation';
import S from './SingularPaymentInformation.module.scss';
export const SingularPaymentInformation = (props: PaymentInformationProps) => {
  const {
    customerName,
    paymentInformation: {
      countryCode
    }
  } = props;
  const isShowZipCodeInput = !(countryCode === 'KR' || countryCode === 'JP');
  return <div className={S.wrapper} data-sentry-component="SingularPaymentInformation" data-sentry-source-file="SingularPaymentInformation.tsx">
      <div className={S.business_title}>{customerName}</div>
      <div className={S.information_content}>
        <ReusablePaymentInformation {...props} data-sentry-element="ReusablePaymentInformation" data-sentry-source-file="SingularPaymentInformation.tsx" />
        <When condition={isShowZipCodeInput} data-sentry-element="When" data-sentry-source-file="SingularPaymentInformation.tsx">
          <Spacing size={30} data-sentry-element="Spacing" data-sentry-source-file="SingularPaymentInformation.tsx" />
          <ZipCodeInput data-sentry-element="ZipCodeInput" data-sentry-source-file="SingularPaymentInformation.tsx" />
        </When>
      </div>
    </div>;
};
const ZipCodeInput = () => {
  const {
    t
  } = useTranslation(['subscription', 'business'], {
    useSuspense: true
  });
  const {
    register,
    setValue,
    formState: {
      errors
    }
  } = useFormContext<PlanCheckoutFormSchemaType>();
  const {
    name,
    ref,
    onChange
  } = register('zipCode');
  const validateZipCodeInput = (event: FormEvent<HTMLInputElement>) => {
    const value = (event.target as HTMLInputElement).value.replace(/[^0-9]/g, '');
    setValue('zipCode', value);
  };
  return <Stack className="mt-[30px] max-w-[400px]" data-sentry-element="Stack" data-sentry-component="ZipCodeInput" data-sentry-source-file="SingularPaymentInformation.tsx">
      <TextField error={!!errors?.zipCode?.message} helperText={t(errors?.zipCode?.message as 'subscription:payment.zipCode.minErrorText')} data-sentry-element="TextField" data-sentry-source-file="SingularPaymentInformation.tsx">
        <div className={S.row_title}>
          {t('subscription:payment.zipCode.title')}
        </div>
        <Input name={name} ref={ref} onChange={onChange} size={'sm'} type="number" maxLength={10} onInput={validateZipCodeInput} placeholder={t('subscription:payment.zipCode.placeholder')} isFullWidth error={!!errors?.zipCode?.message} data-sentry-element="Input" data-sentry-source-file="SingularPaymentInformation.tsx" />
      </TextField>
    </Stack>;
};